import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';

import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { TranslateModule } from '@ngx-translate/core';
import { MaterialModule } from './material/material.module';

// COMPONENTS
import { FooterComponent } from './footer/footer.component';
import { NavbarComponent } from './navbar/navbar.component';
import { SidebarComponent } from './sidebar/sidebar.component';
import { NotificationSidebarComponent } from './notification-sidebar/notification-sidebar.component';

// DIRECTIVES
import { ToggleFullscreenDirective } from './directives/toggle-fullscreen.directive';
import { SidebarDirective } from './directives/sidebar.directive';
import { DragDropDirective } from './directives/drag-drop.directive';
import { SidebarLinkDirective } from './directives/sidebarlink.directive';
import { SidebarListDirective } from './directives/sidebarlist.directive';
import { SidebarAnchorToggleDirective } from './directives/sidebaranchortoggle.directive';
import { SidebarToggleDirective } from './directives/sidebartoggle.directive';
import { TableLayoutComponent } from './table-layout/table-layout.component';
import { EditButtonTableComponent } from './table-action-buttons/edit-button/edit-button.component';
import { DeleteButtonTableComponent } from './table-action-buttons/delete-button/delete-button.component';
import { ViewButtonTableComponent } from './table-action-buttons/view-button/view-button.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { ReadOnlyComponent } from './table-action-buttons/read-only/read-only.component';
import { SweetAlert2Module } from '@sweetalert2/ngx-sweetalert2';
import { DragableListComponent } from './dragable-list/dragable-list.component';
import { DragDropModule } from '@angular/cdk/drag-drop';
import { SelectComponent } from './table-filters-item/select/select.component';
import { InputComponent } from './table-filters-item/input/input.component';
import { FileBtnComponent } from './file-btn/file-btn.component';
import { TruncateCustomPipe } from './pipe/truncate-custom.pipe';
import { EnumToArrayPipe } from './pipe/enum-to-array.pipe';
import { FlowFilterComponent } from './flow-filter/flow-filter.component';
import { SectorFilterComponent } from './sector-filter/sector-filter.component';
import { NgSelectModule } from '@ng-select/ng-select';
import { SearchFilterComponent } from './search-filter/search-filter.component';
import { UploadFilesComponent } from './upload-files/upload-files.component';
import { DeleteFileButtonComponent } from './table-action-buttons/delete-file-button/delete-file-button.component';
import { LoaderComponent } from './loader/loader.component';
import { MatPaginatorIntl } from '@angular/material/paginator';
import { ShowFileComponent } from './show-file/show-file.component';
import { SwapButtonComponent } from './table-action-buttons/swap-button/swap-button.component';
import { SwapModalComponent } from 'app/shared/swap-modal/swap-modal.component';
import { ImportCsvBtnComponent } from './import-csv-btn/import-csv-btn.component';
import { GeneralButtonComponent } from './table-action-buttons/general-button/general-button.component';
import { NoDataComponent } from './components/no-data/no-data.component';
import { FilterInputModule } from './components/filter-input/filter-input.module';
import { TableFiltersComponent } from './table-filters/table-filters.component';
import { InputDateComponent } from './table-filters-item/input-date/input-date.component';
import { SelectSearchSimpleComponent } from './table-filters-item/select-search-simple/select-search-simple.component';
import { ViewImageButtonTableComponent } from './table-action-buttons/view-image/view-image-button.component';
import { InputDateRangeComponent } from './table-filters-item/input-date-range/input-date-range.component';

const spanishRangeLabel = (page: number, pageSize: number, length: number) => {
    if (length === 0 || pageSize === 0) { return `0 de ${length}`; }

    length = Math.max(length, 0);

    const startIndex = page * pageSize;

    // If the start index exceeds the list length, do not try and fix the end index to the end.
    const endIndex = startIndex < length ?
        Math.min(startIndex + pageSize, length) :
        startIndex + pageSize;

    return `${startIndex + 1} - ${endIndex} de ${length}`;
};


export function getSpanishPaginatorIntl() {
    const paginatorIntl = new MatPaginatorIntl();

    paginatorIntl.itemsPerPageLabel = 'Items por página:';
    paginatorIntl.nextPageLabel = 'Siguiente';
    paginatorIntl.previousPageLabel = 'Anterior';
    paginatorIntl.getRangeLabel = spanishRangeLabel;

    return paginatorIntl;
}

const components = [
    TableFiltersComponent,
    TableLayoutComponent,
    EditButtonTableComponent,
    DeleteButtonTableComponent,
    ViewButtonTableComponent,
    ViewImageButtonTableComponent,
    ReadOnlyComponent,
    DragableListComponent,
    SelectComponent,
    SelectSearchSimpleComponent,
    InputComponent,
    InputDateComponent,
    InputDateRangeComponent,
    FileBtnComponent,
    FlowFilterComponent,
    SectorFilterComponent,
    SearchFilterComponent,
    UploadFilesComponent,
    DeleteFileButtonComponent,
    LoaderComponent,
    ShowFileComponent,
    SwapModalComponent,
    SwapButtonComponent,
    ImportCsvBtnComponent,
    GeneralButtonComponent,
    NoDataComponent
];
const pipes = [
    TruncateCustomPipe,
    EnumToArrayPipe
];
@NgModule({
    exports: [
        CommonModule,
        FooterComponent,
        NavbarComponent,
        SidebarComponent,
        NotificationSidebarComponent,
        ToggleFullscreenDirective,
        SidebarDirective,
        NgbModule,
        TranslateModule,
        MaterialModule,
        FormsModule,
        ReactiveFormsModule,
        ...components,
        ...pipes,
    ],
    imports: [
        RouterModule,
        CommonModule,
        NgbModule,
        TranslateModule,
        MaterialModule,
        FormsModule,
        ReactiveFormsModule,
        SweetAlert2Module,
        NgSelectModule,
        ReactiveFormsModule,
        FormsModule,
        FilterInputModule,
        DragDropModule,
        FooterComponent,
        NavbarComponent,
        SidebarComponent,
        NotificationSidebarComponent,
        ...components,
        ...pipes,
        ToggleFullscreenDirective,
        SidebarDirective,
        SidebarLinkDirective,
        SidebarListDirective,
        SidebarAnchorToggleDirective,
        SidebarToggleDirective,
        DragDropDirective,
    ],
    providers: [
        { provide: MatPaginatorIntl, useValue: getSpanishPaginatorIntl() }
    ]
})
export class SharedModule { }
